<template>
  <div class="h-full">
    <UserList
      v-if="!query || filteredUsers.length > 0"
      :users="filteredUsers"
      :selected="internalState"
      @update:selected="emit('change', $event)"
      type="multiple"
    />
    <NoUsers v-else :query="query" />
  </div>
</template>

<script setup>
import { computed, ref, watchEffect, watch } from "vue";
import { isEqual, sortBy, clone } from "lodash";
import { UserList, NoUsers } from "@/Components/Users";
import { useUsers } from "@/Composables/useUsers";

const emit = defineEmits(["apply", "change", "isLoaded"]);

const props = defineProps({
  initialState: { type: Array, default: () => [] },
  query: { type: String, default: "" },
  siteIds: { type: Array, required: false },
});

const internalState = clone(ref([...props.initialState]));

const { isLoading, data } = useUsers(props.siteIds);

const users = computed(() => {
  if (isLoading.value) {
    return [];
  }
  return sortBy(data.value, "fullname");
});

const parsedQuery = computed(() => props.query.trim().toLowerCase());

const filteredUsers = computed(() => {
  if (!parsedQuery.value) {
    return users.value;
  }
  return Object.values(users.value).filter((user) => {
    return user.fullname.trim().toLowerCase().includes(parsedQuery.value);
  });
});

const disableApply = computed(() => {
  return isEqual(sortBy(props.initialState), sortBy(internalState.value));
});

watch(internalState.value, () => {
  emit("change", internalState.value);
});

watchEffect(() => {
  if (!isLoading.value) {
    emit("isLoaded");
  }
});

function handleApply() {
  emit("apply", internalState.value);
}

defineExpose({
  showBack: false,
  showApply: true,
  showSearch: true,
  disableApply,
  handleBack: () => {},
  handleApply,
});
</script>
